import { FC } from 'react';
import { line } from 'd3-shape';

const STROKE_WIDTH = 1;
const LINE_COLOR = '#ccc';

interface ProjectionProps {
    x: number;
    y1: number;
    y2: number;
}

const Projection: FC<ProjectionProps> = ({ x, y1, y2 }) => {
    const path = line()([
        [x, y1],
        [x, y2],
    ]);
    if (!path) {
        return null;
    }
    return <path fill="none" stroke={LINE_COLOR} strokeWidth={STROKE_WIDTH} d={path} />;
};

export default Projection;
